<template>
  <div>
    <label
      :style="hasError && hasState ? 'animation:v-shake 0.6s cubic-bezier(0.25, 0.8, 0.5, 1);' : ''"
      :class="hasError && hasState ? 'error--text' : ''"
      style="font-size:12px"
    >
      {{ titulo }}
    </label>
    <div :class="['dropbox', maxNum > 1 ? 'paddingDropbox' : '']" :style="estilo">
      <div
        :class="[
          'dropbox-background',
          !canDrop ? 'remove-drop' : '',
          maxNum > 1 ? 'paddingDropbox' : '',
          hovering ? 'hover' : ''
        ]"
        style="min-width: 100%"
        :style="maxNum > 1 ? { width: value.length * 160 + 60 + 'px' } : {}"
        @mouseover="mouseOver"
        @mouseout="mouseOut"
        @dragover.stop="dragOver"
        @dragleave="dragLeave"
      >
        <input
          type="file"
          :multiple="maxNum > 1"
          :name="uploadFieldName"
          :disabled="!canDrop"
          @change="
            filesChange($event.target.name, $event.target.files)
            $event.target.value = ''
          "
          @drop.stop
          :class="['input-file', !canDrop ? 'remove-drop' : '']"
          :style="{ height: '100%' }"
          :accept="accept"
        />
      </div>
      <v-flex v-if="value.length === 0" class="dropbox-message">
        <v-icon style="font-size:50px">{{icon}}</v-icon>
        <div>
          {{ maxNum > 1 ? $t('inputs.fileUploader.dragMulti') : $t('inputs.fileUploader.drag') }}
        </div>
      </v-flex>
      <draggable
        v-if="value.length > 0"
        v-model="uploadedFilesComputed" id="uploadedFilesComputed"
        class="image-list"
        :class="singleImage ? 'pa-0 ma-0' : ''"
        :disabled="maxNum === 1 || value.length < 2"
        :forceFallback="true"
        :preventOnFilter="true"
        filter=".no-draggable"
        @start="onStart"
        @end="onEnd"
      >
        <div
          v-for="(item, index) in value"
          :key="item.id ? item.id : item.id_temporal"
          :class="[
            'image-list-item',
            maxNum > 1 && value.length > 1 ? 'draggable' : 'noDrag',
            dragging ? 'hide-remove' : '',
            singleImage ? 'ma-0' : ''
          ]"
          :style="singleImage ? 'width: 100% !important' : ''"
        >

          <FilePreview
            :class="[
              'image-list-image',
              value.length < 2 ? 'noDrag' : '',
              fileRules.length > 0 && !comprobarErrores[index].isValid ? 'bordeRojo' : ''
            ]"
            :imageFill="singleImage"
            :saveAction="saveAction"
            :style="singleImage ? 'width: 100% !important' : ''"
            :file="item"
            @remove="remove(index)"
            :deletable="deletable"
            :interactable="interactable"
            @ampliar="mostrarImagenAmpliada(index)"
            @guardar="$emit('guardar')"
          />
        </div>
      </draggable>
      <custom-dialog v-if="mostrarImagen" v-model="mostrarImagen" id="mostrarImagen" :subPopUp="subPopUp">
        <v-container>
          <v-layout justify-center>
            <v-img
              class="fullScreenCarousel"
              :src="base64(value[index])"
              contain
            />
          </v-layout>
        </v-container>
      </custom-dialog>
    </div>
    <div class="v-text-field__deatils">
      <div class="v-messages theme--light error--text">
        <div class="v-sessages__wrapper">
          <v-slide-y-transition>
            <div class="v-messages__message" v-if="validations.length > 0">
              {{ validations[0] }}
            </div>
          </v-slide-y-transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { upload } from './filePreviewUpload.js'
import FilePreview from './FilePreview'
import uniqid from 'uniqid'
import draggable from 'vuedraggable'
import { mapActions } from 'vuex'
import Validatable from 'vuetify/es5/mixins/validatable'

export default {
  name: 'file-uploader',
  mixins: [Validatable],
  components: {
    FilePreview,
    draggable
  },
  props: {
    icon: {
      type: String,
      default: 'mdi-paperclip'
    },
    maxNum: {
      default: 1,
      type: Number
    },
    uploadFieldName: {
      default: 'image',
      type: String
    },
    value: {
      type: Array
    },
    deletable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    interactable: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: ''
    },
    imagesOnly: {
      type: Boolean,
      default: false
    },
    subPopUp: {
      type: Boolean,
      default: false
    },
    estilo: {
      type: String,
      default: 'min-height: 140px'
    },
    titulo: {
      type: String,
      default: ''
    },
    fileRules: {
      type: Array,
      default: () => [
        value => {
          return !value || value.nombre.length < 90 || 'El nombre del documento no puede superar los 90 caracteres.'
        },
        value => {
          return !value || value.tamanio < 10000000 || 'El tamaño del fichero no puede ser superior a 10Mb'
        }
      ]
    },
    singleImage: {
      type: Boolean,
      default: false
    },
    saveAction: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dragging: false,
      hovering: false,
      index: 0,
      mostrarImagen: false
    }
  },
  computed: {
    canDrop () {
      return !this.disabled && (!this.dragging && this.maxNum > this.value.length)
    },
    uploadedFilesComputed: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    },
    comprobarErrores () {
      return this.value.map(x => {
        const error = []
        for (let index = 0; index < this.fileRules.length; index++) {
          const rule = this.fileRules[index]
          const valid = typeof rule === 'function' ? rule(x) : rule

          if (typeof valid === 'string') {
            error.push(valid)
          } else if (typeof valid !== 'boolean') {
            // eslint-disable-next-line
            console.error(`Rules should return a string or boolean, received '${typeof valid}' instead`, this)
          }
        }
        let isValid = error.length === 0
        return { error, isValid }
      })
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add'
    }),
    validate (force, value) {
      const errorBucket = []
      value = value || this.internalValue

      if (force) this.hasInput = this.hasFocused = true

      if (this.fileRules.length > 0) {
        this.comprobarErrores.forEach(x => {
          if (!x.isValid) {
            errorBucket.push(x.error[0])
          }
        })
      }

      for (let index = 0; index < this.rules.length; index++) {
        const rule = this.rules[index]
        const valid = typeof rule === 'function' ? rule(value) : rule

        if (typeof valid === 'string') {
          errorBucket.push(valid)
        } else if (typeof valid !== 'boolean') {
          // eslint-disable-next-line
          console.error(`Rules should return a string or boolean, received '${typeof valid}' instead`, this)
        }
      }

      this.errorBucket = errorBucket
      this.valid = errorBucket.length === 0

      return this.valid
    },
    mostrarImagenAmpliada (index) {
      this.index = index
      this.mostrarImagen = true
    },
    reset () {
      // reset form to initial state
      this.$emit('input', [])
    },
    remove (index) {
      const newVal = this.value
      newVal.splice(index, 1)
      this.$emit('input', newVal)
    },
    save (formData, file) {
      // upload data to the server
      upload(formData)
        .then(x => {
          if (this.imagesOnly && x[0].mime != null && !x[0].mime.startsWith('image')) {
            this.addAlert({
              texto: this.$t('inputs.fileUploader.alertaImg'),
              color: 'error'
            })
          } else {
            const newFile = {
              id_temporal: uniqid(),
              status: 'SAVING',
              file: file,
              error: ''
            }
            let documento = x[0].documentoGrande.split(',')[1]
            newFile.prefijo = x[0].documentoGrande.split(',')[0]
            newFile.nombre = x[0].nombre
            newFile.mime = x[0].mime
            newFile.documentoGrande = documento
            newFile.extension = x[0].extension
            let s = encodeURI(documento).split(/%..|./).length - 1
            newFile.tamanio = s
            newFile.status = 'SUCCESS'
            let newVal = this.value
            newVal.push(newFile)
            this.$emit('input', newVal)
          }
        })
        .catch(err => {
          this.addAlert({ texto: err.message, color: 'error' })
          // newFile.error = err.message
          // newFile.status = 'FAILED'
          // this.$emit('input', newVal)
        })
    },
    filesChange (fieldName, fileList) {
      // handle file changes
      const filesToUpload = Math.min(fileList.length, this.maxNum - this.value.length)
      if (!fileList.length || filesToUpload <= 0) {
        return
      }
      for (let i = 0; i < filesToUpload; i++) {
        let formData = new FormData()
        formData.append(fieldName, fileList[i], fileList[i].name)
        this.save(formData, fileList[i])
      }
    },
    onStart () {
      this.dragging = true
    },
    onEnd () {
      this.dragging = false
    },
    mouseOver () {
      if (!this.dragging) {
        this.hovering = true
      }
    },
    mouseOut () {
      this.hovering = false
    },
    dragOver () {
      if (!this.dragging) {
        this.hovering = true
      }
    },
    dragLeave () {
      this.hovering = false
    },
    componerPrefijo (imagen) {
      console.log(imagen)
    },
    base64 (fichero) {
      let prefijo = 'data:' + fichero.mime + ';base64,'
      return prefijo + '' + fichero.documentoGrande
    }
  },
  beforeDestroy () {}
}
</script>

<style>
.bordeRojo {
  width: 100%;
  height: 100%;
  z-index: 1;
  outline: 1px solid var(--error) !important;
}
.paddingDropbox.dropbox {
  overflow-y: auto;
}
.dropbox {
  position: relative;
  border: 2px solid #e5e5e5;
  border-radius: 2px;
  padding: 5px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}
.dropbox-background {
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  height: 100%;
  background-color: #fff;
  background-repeat: repeat;
  background-position-x: 20.5px;
  background-position-y: 10.25px;
}
.dropbox-background.hover:not(.remove-drop) {
  background-size: 30px 30px;
  background-image: linear-gradient(
    -45deg,
    #f6f6f6 25%,
    transparent 26%,
    transparent 50%,
    #f6f6f6 50%,
    #f6f6f6 75%,
    transparent 76%,
    transparent
  );
  animation: stripes 2s linear infinite;
}
@-moz-keyframes stripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 60px 30px;
  }
}
@-webkit-keyframes stripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 60px 30px;
  }
}
@-o-keyframes stripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 60px 30px;
  }
}
@keyframes stripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 60px 30px;
  }
}
.input-file {
  opacity: 0;
  width: 100%;
  height: 100%;
  max-height: inherit;
}
.input-file:not(.remove-drop) {
  cursor: pointer;
}
.dropbox .dropbox-message {
  margin: 10px;
  font-size: 14px;
  text-align: center;
  justify-content: center;
  align-items: center;
  z-index: 1;
  pointer-events: none;
}
.image-list {
  pointer-events: none;
  vertical-align: middle;
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  flex-direction: row;
}
.image-list.noDrag {
  pointer-events: none;
}
.image-list-item {
  pointer-events: visible;
  display: flex;
  align-items: center;
  flex-grow: 0;
  margin: 5px;
  user-select: none;
  width: 150px;
  max-width: 100%;
}
.image-list-item.noDrag {
  pointer-events: none;
}
.image-list-item.noDrag .image-list-image {
  pointer-events: visible;
}
.image-list-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 100%;
  position: relative;
  background-color: #fff;
  outline: 1px solid #e5e5e5;
  flex-wrap: wrap;
}
.draggable:hover {
  cursor: move;
}
.fullScreenCarousel {
  width: 80vw;
  height: 80vh;
  pointer-events: none;
}
</style>
